import React from 'react';
import { change as changeFieldValue, formValueSelector, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  maxValueMonetario,
  minValueMonetario,
  renderFieldCheck,
  renderFieldMonetarioFormulario,
  renderFieldQuilogramasFormulario,
  renderFieldText,
  requiredSelect,
  required,
} from '../../util/inputs';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import { showErrorMsg } from '../../util/messagesUtil';
import { withRouter } from 'react-router-dom';
import Titulo from '../comum/Titulo';
import { getPerfisVendedores, getVendedorAgencia } from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import { cadastrarBagagem, selecionaBagagem } from '../../actions/bagagem/bagagemActions';
import buscarConfiguracaoExcessoBagagem from '../../actions/empresa/buscarConfiguracaoExcessoBagagem';

export const VALORCOMBINADO = 'VALOR_COMBINADO';
export const VALOR_POR_METRO_CUBICO = 'VALOR_POR_METRO_CUBICO';

const novoItemMetroCubico = () => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  descricao: '',
  comprimento: '',
  largura: '',
  altura: '',
});

const parseDimensaoCm = (v) => {
  if (v === '' || v === undefined || v === null) return 0;
  return Number(String(v).replace(/\./g, '').replace(',', '.')) || 0;
};

const volumeUnitarioM3 = (c, l, a) => {
  const val = (parseDimensaoCm(c) * parseDimensaoCm(l) * parseDimensaoCm(a)) / 1000000;
  return Math.round(val * 1000000) / 1000000;
};

const parseBRL = (v) => {
  if (v === null || v === undefined) return 0;
  const s = String(v).replace(/[^\d.,-]/g, '').replace(/\./g, '').replace(',', '.');
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
};

function calcularValorTotal(reservasSelecionadas, formValues) {
  let total = 0;
  reservasSelecionadas.forEach(r => {
    total += Math.round(parseBRL(formValues && formValues[`valor_${r.id}`]) * 100);
  });
  return Number((total / 100).toFixed(2));
}


function validarFormulario(values, props) {
  const errors = {};
  const reservas = (props && props.reservasSelecionadas) || [];

  reservas.forEach(r => {
    const rid = r.id;
    const valItem = parseBRL(values[`valor_${rid}`]);
    const selecionouAlguma = !!values[`dinheiro_${rid}`] || !!values[`cartao_${rid}`] || !!values[`pix_${rid}`];

      if (!selecionouAlguma) {
          errors[`dinheiro_${rid}`] = 'Selecione pelo menos uma forma de pagamento.';
          return;
        }


    if (selecionouAlguma) {
      const vDin = values[`dinheiro_${rid}`] ? parseBRL(values[`valorDinheiro_${rid}`]) : 0;
      const vCar = values[`cartao_${rid}`] ? parseBRL(values[`valorCartao_${rid}`]) : 0;
      const vPix = values[`pix_${rid}`] ? parseBRL(values[`valorPIX_${rid}`]) : 0;
      const soma = Number((vDin + vCar + vPix).toFixed(2));

      if (values[`dinheiro_${rid}`] && vDin <= 0) {
        errors[`valorDinheiro_${rid}`] = 'O valor em dinheiro não pode ser zero.';
      }
      if (values[`cartao_${rid}`] && vCar <= 0) {
        errors[`valorCartao_${rid}`] = 'O valor em cartão não pode ser zero.';
      }
      if (values[`pix_${rid}`] && vPix <= 0) {
        errors[`valorPIX_${rid}`] = 'O valor em PIX não pode ser zero.';
      }

      if (Math.abs(soma - valItem) > 0.009) { // tolerância de arredondamento
        const msg = 'A soma das formas de pagamento deve ser igual ao valor desta bagagem.';
        if (values[`dinheiro_${rid}`]) errors[`valorDinheiro_${rid}`] = msg;
        if (values[`cartao_${rid}`]) errors[`valorCartao_${rid}`] = msg;
        if (values[`pix_${rid}`]) errors[`valorPIX_${rid}`] = msg;
      }

      // Campos extras quando cartão/PIX selecionados
      if (values[`cartao_${rid}`]) {
        // exemplo opcional: exigir número do comprovante quando cartão
        // if (!values[`numeroComprovante_${rid}`]) errors[`numeroComprovante_${rid}`] = 'Informe o número do comprovante';
      }
      if (values[`pix_${rid}`]) {
        // exemplo opcional: exigir número do comprovante PIX
        // if (!values[`numeroComprovantePIX_${rid}`]) errors[`numeroComprovantePIX_${rid}`] = 'Informe o número do comprovante PIX';
      }
    }
  });

  return errors;
}

class PainelCadastroBagagem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      itensMetroCubico: {},
    };
  }

  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.buscarConfiguracaoExcessoBagagem(this.props.empresaSelecionada.id);
    }
    if (this.props.reservasSelecionadas && this.props.reservasSelecionadas.length) {
      this.props.reservasSelecionadas.forEach(it => {
          this.props.changeFieldValue('formularioCadastroBagagem', `tipoCalculo_${it.id}`, {
            value: 'VALOR_COMBINADO',
            label: 'Valor combinado'
          });
      });
    }
  }

  getItensMetroCubico(rid) {
    return this.state.itensMetroCubico[rid] || [novoItemMetroCubico()];
  }

  sincronizarCalculoMetroCubico(rid, itens) {
    const config = this.props.configuracaoExcessoBagagem || {};
    const precoM3 = parseBRL(config.precoMetroCubico);
    const volumeTotal = itens.reduce((acc, it) => acc + volumeUnitarioM3(it.comprimento, it.largura, it.altura), 0);
    const volumeTotalArred = Math.round(volumeTotal * 1000000) / 1000000;
    const valorTotal = Math.round(volumeTotalArred * precoM3 * 100) / 100;
    const valorFormatado = valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    this.setState(prev => ({ itensMetroCubico: { ...prev.itensMetroCubico, [rid]: itens } }));
    this.props.changeFieldValue('formularioCadastroBagagem', `valor_${rid}`, valorFormatado);
  }

  adicionarCaixaMetroCubico(rid) {
    const itens = [...this.getItensMetroCubico(rid), novoItemMetroCubico()];
    this.sincronizarCalculoMetroCubico(rid, itens);
  }

  removerCaixaMetroCubico(rid, id) {
    const base = this.getItensMetroCubico(rid).filter(it => it.id !== id);
    const itens = base.length ? base : [novoItemMetroCubico()];
    this.sincronizarCalculoMetroCubico(rid, itens);
  }

  alterarCampoCaixaMetroCubico(rid, index, campo, valor) {
    const itens = [...this.getItensMetroCubico(rid)];
    if (!itens[index]) return;
    itens[index] = { ...itens[index], [campo]: valor };
    this.sincronizarCalculoMetroCubico(rid, itens);
  }

  handleToggleForma = (reservaId, forma) => {
    const { changeFieldValue, formValues } = this.props;
    const flagField = `${forma}_${reservaId}`; // dinheiro_#, cartao_#, pix_#
    const isAtivo = !!(formValues && formValues[flagField]);
    const novo = !isAtivo;

    changeFieldValue('formularioCadastroBagagem', flagField, novo);

    if (novo) {
      const jaSelecionadas = [ 'dinheiro', 'cartao', 'pix' ]
        .filter(f => !!(formValues && formValues[`${f}_${reservaId}`]))
        .length;
      if (jaSelecionadas === 0) {
        const valorItem = formValues && formValues[`valor_${reservaId}`];
        const valorField = (forma === 'dinheiro') ? `valorDinheiro_${reservaId}`
                          : (forma === 'cartao') ? `valorCartao_${reservaId}`
                          : `valorPIX_${reservaId}`;
        changeFieldValue('formularioCadastroBagagem', valorField, valorItem);
      }
    } else {
      if (forma === 'dinheiro') {
        changeFieldValue('formularioCadastroBagagem', `valorDinheiro_${reservaId}`, null);
      } else if (forma === 'cartao') {
        changeFieldValue('formularioCadastroBagagem', `valorCartao_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `numeroComprovante_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `quantidadeParcelas_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `base64Comprovante_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVenda_${reservaId}`, null);
      } else if (forma === 'pix') {
        changeFieldValue('formularioCadastroBagagem', `valorPIX_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `numeroComprovantePIX_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `base64ComprovantePIX_${reservaId}`, null);
        changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVendaPIX_${reservaId}`, null);
      }
    }
  };


  handleAnexarCartao = (e, reservaId) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return;
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return;
    }
    this.converterParaBase64(file, 'CARTAO', reservaId);
  };

  handleAnexarPix = (e, reservaId) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return;
    if (file.size > tamanhoArquivoUpload) {
      showErrorMsg('Tamanho do arquivo excede 20 MB');
      return;
    }
    this.converterParaBase64(file, 'PIX', reservaId);
  };

  converterParaBase64 = (file, formaPagamento, reservaId) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (formaPagamento === 'PIX') {
        this.props.changeFieldValue('formularioCadastroBagagem', `base64ComprovantePIX_${reservaId}`, reader.result);
        this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVendaPIX_${reservaId}`, file.name);
      } else {
        this.props.changeFieldValue('formularioCadastroBagagem', `base64Comprovante_${reservaId}`, reader.result);
        this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVenda_${reservaId}`, file.name);
      }
    };
    reader.readAsDataURL(file);
  };

  removerArquivo = (formaPagamento, reservaId) => {
    if (formaPagamento === 'PIX') {
      this.props.changeFieldValue('formularioCadastroBagagem', `base64ComprovantePIX_${reservaId}`, null);
      this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVendaPIX_${reservaId}`, null);
    } else {
      this.props.changeFieldValue('formularioCadastroBagagem', `base64Comprovante_${reservaId}`, null);
      this.props.changeFieldValue('formularioCadastroBagagem', `nomeComprovanteVenda_${reservaId}`, null);
    }
  };

  exibirAnexarCartao = (reservaId) => {
    const { formValues } = this.props;
    if (formValues && formValues[`base64Comprovante_${reservaId}`]) {
      return (
        <div className="row align-items-center mt-2">
          <div className='col-12 label-cancelamento'>
            <label>Comprovante:</label>
          </div>
          <div className='ml-4'>{formValues[`nomeComprovanteVenda_${reservaId}`]}</div>
          <button type="button" className="btn btn-editar" title='Remover' onClick={() => this.removerArquivo('CARTAO', reservaId)}>
            <i className="material-icons nav-icon" style={{ color: 'red' }}>&#xe14c;</i>
          </button>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className='input-wrapper mt-3'>
          <label className='btn-laranja' htmlFor={`input-file-cartao-${reservaId}`}>
            <div className='row align-items-center'>
              <i className="material-icons aberto">&#xe2c3;</i>
              <strong className='ml-2'>Anexar comprovante de pagamento</strong>
            </div>
          </label>
          <input id={`input-file-cartao-${reservaId}`} type='file' accept="image/png,image/jpeg,application/pdf" onChange={(e) => this.handleAnexarCartao(e, reservaId)} style={{ display: 'none' }} />
        </div>
        <label style={{ fontSize: 'smaller' }}>* Tamanho máximo permitido : 20 MB</label>
      </React.Fragment>
    );
  };

  exibirAnexarPix = (reservaId) => {
    const { formValues } = this.props;
    if (formValues && formValues[`base64ComprovantePIX_${reservaId}`]) {
      return (
        <div className="row align-items-center mt-2">
          <div className='col-12 label-cancelamento'>
            <label>Comprovante:</label>
          </div>
          <div className='ml-4'>{formValues[`nomeComprovanteVendaPIX_${reservaId}`]}</div>
          <button type="button" className="btn btn-editar" title='Remover' onClick={() => this.removerArquivo('PIX', reservaId)}>
            <i className="material-icons nav-icon" style={{ color: 'red' }}>&#xe14c;</i>
          </button>
        </div>
      );
    }
    return (
      <div className='input-wrapper mt-3'>
        <label className='btn-laranja' htmlFor={`input-file-pix-${reservaId}`}>
          <div className='row align-items-center'>
            <i className="material-icons aberto">&#xe2c3;</i>
            <strong className='ml-2'>Anexar comprovante de pagamento</strong>
          </div>
        </label>
        <input id={`input-file-pix-${reservaId}`} type='file' accept="image/png,image/jpeg,application/pdf" onChange={(e) => this.handleAnexarPix(e, reservaId)} style={{ display: 'none' }} />
      </div>
    );
  };

  exibirComboTipoCalculo = (event) => {
    const config = this.props.configuracaoExcessoBagagem || {};
    const tiposCalculo = [
      { value: 'VALOR_COMBINADO', label: 'Valor combinado' },
      ...(config.habilitadoPrecoKg ? [{ value: 'VALOR_POR_KG', label: 'Valor por KG' }] : []),
      ...(config.habilitadoPrecoFixoMaisValorKg ? [{ value: 'PRECO_FIXO_MAIS_VALOR_POR_KG', label: 'Preço fixo + Valor Kg' }] : []),
      ...(config.habilitadoPrecoMetroCubico ? [{ value: 'VALOR_POR_METRO_CUBICO', label: 'Valor Por Metro Cúbico(M³)' }] : []),
    ];
    return (
      <div>
        <Select
          {...event.input}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
          placeholder='Tipo de cálculo'
          options={tiposCalculo}
          onChange={value => event.input.onChange(value)}
          onBlur={() => event.input.onBlur()}
          label="Tipo de cálculo"
        />
        {event.meta.touched && event.meta.error && (
          <span style={{ color: 'red' }}>{event.meta.error}</span>
        )}
      </div>
    );
  };

  exibirSecaoCalculoMetroCubico(rid) {
    const config = this.props.configuracaoExcessoBagagem || {};
    const precoM3 = parseBRL(config.precoMetroCubico);
    const itens = this.getItensMetroCubico(rid);
    const volumeTotal = itens.reduce((acc, it) => acc + volumeUnitarioM3(it.comprimento, it.largura, it.altura), 0);
    const volumeTotalArred = Math.round(volumeTotal * 1000000) / 1000000;
    const valorTotal = Math.round(volumeTotalArred * precoM3 * 100) / 100;

    const primeiraCaixa = itens[0];
    let exemploFormula = null;
    if (primeiraCaixa) {
      const c = parseDimensaoCm(primeiraCaixa.comprimento);
      const l = parseDimensaoCm(primeiraCaixa.largura);
      const a = parseDimensaoCm(primeiraCaixa.altura);
      if (c > 0 && l > 0 && a > 0) {
        const vu = volumeUnitarioM3(primeiraCaixa.comprimento, primeiraCaixa.largura, primeiraCaixa.altura);
        const rotulo = (primeiraCaixa.descricao && String(primeiraCaixa.descricao).trim()) || '1ª caixa';
        exemploFormula = (
          <p className="encomenda-metro-cubico-formula-exemplo">
            Ex.: <strong>{rotulo}</strong> — ({c.toLocaleString('pt-BR')} × {l.toLocaleString('pt-BR')} × {a.toLocaleString('pt-BR')}) / 1.000.000 ={' '}
            <strong>{vu.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³</strong>
          </p>
        );
      }
    }

    return (
      <div className="col-12 encomenda-metro-cubico-wrap">
        <div className="encomenda-metro-cubico-titulo">Cálculo do Metro Cúbico</div>
        <div className="row align-items-start">
          <div className="col-12 col-lg-8 pr-lg-4 mb-4 mb-lg-0">
            <fieldset className="encomenda-metro-cubico-fieldset">
              <legend>Adicionar Caixas</legend>
              <div className="table-responsive">
                <table className="table table-bordered table-sm mb-0 encomenda-metro-cubico-table">
                  <thead>
                    <tr>
                      <th rowSpan={2} className="text-center align-middle" style={{ width: 40 }}>#</th>
                      <th rowSpan={2} className="align-middle" style={{ minWidth: 140 }}>Descrição da Caixa</th>
                      <th colSpan={3} className="text-center align-middle">Dimensões (cm)</th>
                      <th rowSpan={2} className="text-center align-middle" style={{ minWidth: 110 }}>Volume Unitário (m³)</th>
                      <th rowSpan={2} className="text-center align-middle" style={{ width: 64 }}>Ações</th>
                    </tr>
                    <tr>
                      <th className="text-center">Comprimento (C)</th>
                      <th className="text-center">Largura (L)</th>
                      <th className="text-center">Altura (A)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itens.map((it, idx) => {
                      const vu = volumeUnitarioM3(it.comprimento, it.largura, it.altura);
                      return (
                        <tr key={it.id}>
                          <td className="text-center text-muted">{idx + 1}</td>
                          <td>
                            <input type="text" className="form-control form-control-sm" value={it.descricao}
                              placeholder="Ex.: Caixa 1"
                              onChange={ev => this.alterarCampoCaixaMetroCubico(rid, idx, 'descricao', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-dim">
                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                              placeholder="cm" value={it.comprimento}
                              onChange={ev => this.alterarCampoCaixaMetroCubico(rid, idx, 'comprimento', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-dim">
                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                              placeholder="cm" value={it.largura}
                              onChange={ev => this.alterarCampoCaixaMetroCubico(rid, idx, 'largura', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-dim">
                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                              placeholder="cm" value={it.altura}
                              onChange={ev => this.alterarCampoCaixaMetroCubico(rid, idx, 'altura', ev.target.value)} />
                          </td>
                          <td className="encomenda-metro-cubico-col-vol align-middle text-center">
                            {vu.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}
                          </td>
                          <td className="text-center align-middle">
                            <button type="button" className="btn btn-link p-1" title="Remover caixa"
                              onClick={() => this.removerCaixaMetroCubico(rid, it.id)}>
                              <i className="material-icons nav-icon" style={{ color: '#e53935', fontSize: '22px' }}>&#xe872;</i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <button type="button" className="btn encomenda-metro-cubico-btn-adicionar"
                onClick={() => this.adicionarCaixaMetroCubico(rid)}>
                <i className="material-icons" style={{ fontSize: '20px' }}>&#xe145;</i>
                ADICIONAR OUTRA CAIXA
              </button>
            </fieldset>
          </div>
          <div className="col-12 col-lg-4">
            <div className="encomenda-metro-cubico-sidebar">
              <div className="encomenda-metro-cubico-formula">
                <strong>Fórmula</strong>
                <div className="encomenda-metro-cubico-formula-expr">m³ = (C × L × A) / 1.000.000</div>
                {exemploFormula || (
                  <p className="encomenda-metro-cubico-formula-exemplo mb-0">
                    Informe comprimento, largura e altura em centímetros para ver um exemplo com a primeira caixa.
                  </p>
                )}
              </div>
              <div className="encomenda-metro-cubico-resumo">
                <div className="encomenda-metro-cubico-resumo-titulo">Resumo do Volume</div>
                <div className="encomenda-metro-cubico-resumo-linha">
                  <strong>Total de caixas:</strong> {itens.length}
                </div>
                <div className="encomenda-metro-cubico-resumo-valor-label">Volume total</div>
                <div className="encomenda-metro-cubico-resumo-valor">
                  {volumeTotalArred.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³
                </div>
                <div className="encomenda-metro-cubico-resumo-valor-total">
                  <div className="encomenda-metro-cubico-resumo-valor-label">Valor total (volume × R$/m³)</div>
                  <div className="encomenda-metro-cubico-resumo-valor">
                    {valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  calcularValorKg = (reservaId) => {
    const { formValues, changeFieldValue } = this.props;
    const config = this.props.configuracaoExcessoBagagem || {};
    const tipoCalculo = formValues && formValues[`tipoCalculo_${reservaId}`];
    if (!tipoCalculo) return;
    const peso = parseBRL(formValues && formValues[`peso_${reservaId}`]);
    if (peso <= 0) return;

    if (tipoCalculo.value === 'VALOR_POR_KG' && config.precoKg) {
      const valor = Number((peso * parseBRL(config.precoKg)).toFixed(2));
      const valorFormatado = valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      changeFieldValue('formularioCadastroBagagem', `valor_${reservaId}`, valorFormatado);
    } else if (tipoCalculo.value === 'PRECO_FIXO_MAIS_VALOR_POR_KG' && config.precoFixo && config.valorKg) {
      const valor = Number((parseBRL(config.precoFixo) + peso * parseBRL(config.valorKg)).toFixed(2));
      const valorFormatado = valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      changeFieldValue('formularioCadastroBagagem', `valor_${reservaId}`, valorFormatado);
    }
  };

  ehPerfilVendedorAgencia = () => {    
    return validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)]);
  }

  exibir = (reserva) => {
    const { formValues } = this.props;
    const config = this.props.configuracaoExcessoBagagem || {};
    const rid = reserva.id;
    const temDinheiro = !!(formValues && formValues[`dinheiro_${rid}`]);
    const temCartao = !!(formValues && formValues[`cartao_${rid}`]);
    const temPix = !!(formValues && formValues[`pix_${rid}`]);
    const tipoCalculo = formValues && formValues[`tipoCalculo_${rid}`];
    const ehMetroCubico = tipoCalculo && tipoCalculo.value === VALOR_POR_METRO_CUBICO;
    const valorReadOnly = reserva.habilitadoPrecoFixoExcessoBagagem || ehMetroCubico
      || tipoCalculo && (tipoCalculo.value === 'VALOR_POR_KG' || tipoCalculo.value === 'PRECO_FIXO_MAIS_VALOR_POR_KG');

    return (
      <div className="col-12" key={rid}>
        <div className="card">
          <div className="card-body">
            <div className="alert alert-info" style={{ fontWeight: 'bold' }}>
              <strong>Reserva : {rid}</strong> - {reserva.passageiroDto.nome} - {reserva.descCidadeDestino} à {reserva.descCidadeOrigem}
            </div>

            <div className="form-row align-items-end">
              <div className="form-group col-md-3">
                <Field name={`tipoCalculo_${rid}`} validate={[requiredSelect]} component={this.exibirComboTipoCalculo} />
              </div>

              {tipoCalculo && tipoCalculo.value === 'VALOR_POR_METRO_CUBICO' && config.precoMetroCubico && (
                <div className="form-group col-md-3">
                  <label>Valor por m³ (R$)</label>
                  <input className="form-control" readOnly
                    value={parseBRL(config.precoMetroCubico).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
                </div>
              )}

              {tipoCalculo && tipoCalculo.value === 'VALOR_POR_KG' && config.precoKg && (
                <div className="form-group col-md-2">
                  <label>Preço por KG</label>
                  <input className="form-control" readOnly
                    value={parseBRL(config.precoKg).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
                </div>
              )}

              {tipoCalculo && tipoCalculo.value === 'PRECO_FIXO_MAIS_VALOR_POR_KG' && (
                <>
                  {config.precoFixo && (
                    <div className="form-group col-md-2">
                      <label>Preço Fixo</label>
                      <input className="form-control" readOnly
                        value={parseBRL(config.precoFixo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
                    </div>
                  )}
                  {config.valorKg && (
                    <div className="form-group col-md-2">
                      <label>Valor por KG</label>
                      <input className="form-control" readOnly
                        value={parseBRL(config.valorKg).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
                    </div>
                  )}
                </>
              )}

              {!ehMetroCubico && (
                <div className="form-group col-md-3">
                  <Field
                    name={`peso_${rid}`}
                    type="number"
                    component={renderFieldQuilogramasFormulario}
                    css="form-control"
                    placeholder="Peso da bagagem"
                    validate={[required, minValueMonetario]}
                    label="Kg"
                    onChange={() => setTimeout(() => this.calcularValorKg(rid), 0)}
                  />
                </div>
              )}

              <div className="form-group col-md-3">
                <Field
                  name={`valor_${rid}`}
                  type="text"
                  component={renderFieldMonetarioFormulario}
                  css="form-control"
                  placeholder="Valor da bagagem"
                  validate={[required, maxValueMonetario, minValueMonetario]}
                  readOnly={valorReadOnly}
                />
              </div>
            </div>

            {ehMetroCubico && this.exibirSecaoCalculoMetroCubico(rid)}

            {config.habilitadoTaxaSeguro && (
              <div className="form-row">
                <div className="form-group col-md-3">
                  <Field
                    name={`valorSeguro_${rid}`}
                    type="text"
                    component={renderFieldMonetarioFormulario}
                    css="form-control"
                    label="Valor Declarado (para seguro)"
                    placeholder="Valor declarado ou NF"
                  />
                </div>
              </div>
            )}

            <div className="form-row">
              <div className="form-group col-md-6">
                <Field
                  name={`observacao_${rid}`}
                  type="text"
                  component={renderFieldText}
                  css="form-control"
                  label="Observação"
                  placeholder="Observação sobre a bagagem (opcional)"
                />
              </div>
            </div>

            <div className="form-check form-check-inline d-flex justify-content-center">
              {!this.ehPerfilVendedorAgencia() ? <Field
                name={`cartao_${rid}`}
                type="checkbox"
                component={renderFieldCheck}
                label="Cartão"
                onChange={() => this.handleToggleForma(rid, 'cartao')}
              /> : ''}
              <Field
                name={`dinheiro_${rid}`}
                type="checkbox"
                component={renderFieldCheck}
                label="Dinheiro"
                onChange={() => this.handleToggleForma(rid, 'dinheiro')}
              />
              {!this.ehPerfilVendedorAgencia() ? <Field
                name={`pix_${rid}`}
                type="checkbox"
                component={renderFieldCheck}
                label="PIX"
                onChange={() => this.handleToggleForma(rid, 'pix')}
              />: ''}
            </div>

            {temDinheiro && (
              <div className="form-group">
                <Field
                  name={`valorDinheiro_${rid}`}
                  type="text"
                  component={renderFieldMonetarioFormulario}
                  validate={[required, maxValueMonetario, minValueMonetario]}
                  css="form-control col-md-8"
                  label="Valor em dinheiro"
                />
              </div>
            )}

            {temCartao && (
              <div>
                <div className="form-row">
                  <div className="form-group">
                    <Field
                      name={`valorCartao_${rid}`}
                      type="text"
                      component={renderFieldMonetarioFormulario}
                      validate={[required, maxValueMonetario, minValueMonetario]}
                      css="form-control col-md-8"
                      label="Valor em cartão"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name={`numeroComprovante_${rid}`}
                      type="text"
                      component={renderFieldText}
                      css="form-control col-md-8"
                      label="Número comprovante"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name={`quantidadeParcelas_${rid}`}
                      type="text"
                      component={renderFieldText}
                      label="Quantidade de parcelas"
                      css="form-control col-md-3"
                    />
                  </div>
                </div>
                <div className='form-row'>
                  <div className="form-group">
                    {this.exibirAnexarCartao(rid)}
                  </div>
                </div>
              </div>
            )}

            {temPix && (
              <div>
                <div className="form-row">
                  <div className="form-group">
                    <Field
                      name={`valorPIX_${rid}`}
                      type="text"
                      component={renderFieldMonetarioFormulario}
                      validate={[required, maxValueMonetario, minValueMonetario]}
                      css="form-control col-md-8"
                      label="Valor em PIX"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      name={`numeroComprovantePIX_${rid}`}
                      type="text"
                      component={renderFieldText}
                      css="form-control col-md-8"
                      label="Número comprovante PIX"
                    />
                  </div>
                </div>
                <div className='form-row'>
                  <div className="form-group">
                    {this.exibirAnexarPix(rid)}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  handleCadastrarTodas = () => {
    const { reservasSelecionadas, formValues } = this.props;

    const bagagens = reservasSelecionadas.map(r => {
      const rid = r.id;
      const formasPagamento = [];

      if (formValues[`dinheiro_${rid}`]) {
          formasPagamento.push({ tipo: 'DINHEIRO', valor: parseBRL(formValues[`valorDinheiro_${rid}`]) });
      }

      if (formValues[`cartao_${rid}`]) {
         formasPagamento.push({
           tipo: 'CARTAO',
           valor: parseBRL(formValues[`valorCartao_${rid}`]),
           numeroComprovante: formValues[`numeroComprovante_${rid}`],
           quantidadeParcelas: formValues[`quantidadeParcelas_${rid}`],
           base64Comprovante: formValues[`base64Comprovante_${rid}`],
           nomeComprovante: formValues[`nomeComprovanteVenda_${rid}`],
         });
      }

      if (formValues[`pix_${rid}`]) {
         formasPagamento.push({
           tipo: 'PIX',
           valor: parseBRL(formValues[`valorPIX_${rid}`]),
           numeroComprovante: formValues[`numeroComprovantePIX_${rid}`],
           base64Comprovante: formValues[`base64ComprovantePIX_${rid}`],
           nomeComprovante: formValues[`nomeComprovanteVendaPIX_${rid}`],
         });
      }

      const tipoCalculo = formValues[`tipoCalculo_${rid}`];
      const ehMetroCubico = tipoCalculo && tipoCalculo.value === VALOR_POR_METRO_CUBICO;
      const config = this.props.configuracaoExcessoBagagem || {};

      let itensMetroCubico = undefined;
      let volumeTotalMetroCubico = undefined;
      let precoMetroCubico = undefined;

      if (ehMetroCubico) {
        const itens = this.getItensMetroCubico(rid);
        itensMetroCubico = itens.map(it => ({
          descricao: it.descricao || '',
          comprimento: String(it.comprimento).replace('.', ','),
          largura: String(it.largura).replace('.', ','),
          altura: String(it.altura).replace('.', ','),
        }));
        const volTotal = itens.reduce((acc, it) => acc + volumeUnitarioM3(it.comprimento, it.largura, it.altura), 0);
        volumeTotalMetroCubico = String((Math.round(volTotal * 1000000) / 1000000).toFixed(6)).replace('.', ',');
        precoMetroCubico = config.precoMetroCubico != null ? String(config.precoMetroCubico).replace('.', ',') : '0';
      }

      return {
        reservaId: rid,
        peso: ehMetroCubico ? 0 : parseBRL(formValues[`peso_${rid}`]),
        valor: parseBRL(formValues[`valor_${rid}`]),
        valorTipoCalculoBagagem: tipoCalculo.value,
        descTipoCalculoBagagem: tipoCalculo.label,
        valorSeguro: parseBRL(formValues[`valorSeguro_${rid}`]) || 0,
        observacao: formValues[`observacao_${rid}`] || null,
        itensMetroCubico,
        volumeTotalMetroCubico,
        precoMetroCubico,
        formasPagamento,
      };
    });

    const payload = { bagagens };
    console.log('Objeto para cadastro:', payload);
    this.props.cadastrarBagagem(payload).then((response) => {
      // Seleciona a primeira bagagem cadastrada para exibir no recibo
      if (response.payload && response.payload.length > 0) {
        this.props.selecionaBagagem(response.payload[0]);
      }
      // Redireciona para o recibo da bagagem
      this.props.history.push('/recibo-bagagem');
    }).catch(error => {
      console.error('Erro ao cadastrar bagagens:', error);
      if (error.response) {
        const { violacoes } = error.response.data;
        
        violacoes.forEach(violacao => {
          console.error(`Tipo: ${violacao.tipo}`);
          console.error(`Mensagem: ${violacao.mensagem}`);
                    
          showErrorMsg(violacao.mensagem);
        });
        
      } else {        
        showErrorMsg('Erro ao cadastrar bagagens. Verifique os dados e tente novamente.');
      }
    });
  };

  render() {
    const { empresaSelecionada, reservasSelecionadas, formValues } = this.props;
    const valorTotal = calcularValorTotal(reservasSelecionadas, formValues || {});

    return (
      <Autorizacao perfisPermitidos={[...getPerfisVendedores(empresaSelecionada.id)]} empresaSelecionada={empresaSelecionada}>
        <div>
          <div className="row internas">
            <Titulo texto="Pesquisar Reservas" urlRetorno="/painel-pesquisar-bilhete" />
            {reservasSelecionadas.map(r => this.exibir(r))}
          </div>

          <div className="d-flex justify-content-center mt-4">
            <h4>
              <strong>Valor Total: </strong>
              {valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </h4>
          </div>

          <div className="mt-3 d-flex justify-content-center">
            <button
              className="btn btn-laranja btn-sm"
              style={{ minWidth: 180 }}
              onClick={this.handleCadastrarTodas}
              type="button"
              disabled={this.props.invalid || this.props.pristine} // 🔒 controla estado
            >
              Cadastrar Todas as Bagagens
            </button>
          </div>

        </div>
      </Autorizacao>
    );
  }
}

const seletor = formValueSelector('formularioCadastroBagagem');
export const mapStateToProps = state => {
  const reservasSelecionadas = state.reservasExcessoBagagem.reservasSelecionadas || [];
  const nomesCampos = reservasSelecionadas.flatMap(r => [
    `peso_${r.id}`,
    `valor_${r.id}`,
    `tipoCalculo_${r.id}`,
    `valorSeguro_${r.id}`,
    `observacao_${r.id}`,
    `dinheiro_${r.id}`,
    `valorDinheiro_${r.id}`,
    `cartao_${r.id}`,
    `valorCartao_${r.id}`,
    `numeroComprovante_${r.id}`,
    `quantidadeParcelas_${r.id}`,
    `base64Comprovante_${r.id}`,
    `nomeComprovanteVenda_${r.id}`,
    `pix_${r.id}`,
    `valorPIX_${r.id}`,
    `numeroComprovantePIX_${r.id}`,
    `base64ComprovantePIX_${r.id}`,
    `nomeComprovanteVendaPIX_${r.id}`,
  ]);

  const formValues = seletor(state, ...nomesCampos);
    
  const reserva = reservasSelecionadas.find(it => it.habilitadoPrecoFixoExcessoBagagem);
  if (reserva) {
    const valorInicial = nomesCampos.filter(it => it.startsWith('valor_')).map(chave => {
      return { [chave]: reserva.precoFixoExcessoBagagem }
    })

    if (valorInicial && valorInicial.length) {
      const valor = valorInicial.reduce((acc, item) => {
        return {...acc, ...item}
      })

      return {
        initialValues: valor,
        empresaSelecionada: state.empresaSelecionada,
        reservasSelecionadas,
        formValues,
        configuracaoExcessoBagagem: state.configuracaoExcessoBagagem,
      };
    }
  }

  return {
    empresaSelecionada: state.empresaSelecionada,
    reservasSelecionadas,
    formValues,
    configuracaoExcessoBagagem: state.configuracaoExcessoBagagem,
  };
};

export default withRouter(connect(mapStateToProps,
    {   changeFieldValue,
        cadastrarBagagem,
        selecionaBagagem,
        buscarConfiguracaoExcessoBagagem,
    })(
  reduxForm({
    form: 'formularioCadastroBagagem',
    enableReinitialize: true,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    validate: validarFormulario,
  })(PainelCadastroBagagem)
));
